﻿﻿﻿﻿﻿﻿﻿﻿﻿<div *ngIf="!isBulkCatUploadOrder">
  <div class="mb-2">
    <div class="d-flex justify-content-between custom-container py-2"></div>

    <div *ngIf="!noData" class="page_responsive card">
      <div class="card-body">
        <div class="container">
          <div class="d-flex justify-content-between mb-3">
            <div *ngIf="!reviewMode">
              <span class="title_header">Order Summary</span>
            </div>
            <div *ngIf="reviewMode">
              <span class="title_header">Review Order</span>
            </div>

            <div>
              <button
                (click)="viewPdfDocument()"
                *ngIf="
                  order?.status === 'WAITING_FOR_APPROVAL' &&
                  order?.order_type != 'ESTAMP'
                "
                class="button-style me-2"
                type="button"
              >
                <i
                  class="pi pi-eye"
                  style="
                    position: absolute;
                    margin-top: 0px;
                    font-size: 1.1rem !important;
                  "
                ></i>
                <span style="padding-left: 30px"> Review Document </span>
              </button>

              <button
                *ngIf="enableAuditTrial"
                class="button-style"
                type="button"
                (click)="auditDownload()"
              >
                <i class="bx bx-download downloadAuditTrial"></i>
                <span style="padding-left: 30px">Audit Trail </span>
              </button>
            </div>
          </div>

          <div class="data-card">
            <div class="row">
              <div class="col">
                <div class="r1 ms-2">
                  Order ID:<span class="r1s">{{ order?.id }}</span>
                </div>
              </div>
              <div class="col">
                <div class="r1">
                  Service Type:
                  <span class="r1s">{{ order?.order_type_display }}</span>
                </div>
              </div>
              <div class="col">
                <div class="r1">
                  Status:
                  <span
                    [ngStyle]="{
                      'background-color':
                        order?.status === 'COMPLETED'
                          ? 'rgba(0, 146, 58, 0.15)'
                          : 'rgba(224, 144, 7, 0.15)'
                    }"
                    style="
                      color: #151515;
                      padding-inline: 9px !important;
                      padding: 1px;
                      border-radius: 6px;
                      font-weight: 400;
                      font-size: 14px;
                      margin-left: 2px;
                    "
                    >{{ order?.status_display | titlecase }}</span
                  >
                  <button
                    *ngIf="showRefresh"
                    class="button-style_refresh me-2 ms-2"
                    type="button"
                    pTooltip="Refresh Order Details  "
                  >
                    <i class="pi pi-refresh" (click)="refreshOrder()"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="r1 ms-2">
                  Order date:<span class="r1s">{{
                    order?.created | date: "MMMM d, yyyy, h.mm a"
                  }}</span>
                </div>
              </div>
              <div class="col">
                <div class="r1">
                  Order placed by:
                  <span class="r1s">{{ order?.user_name }}</span>
                </div>
              </div>
              <div class="col">
                <div class="r1">
                  {{
                    showHdfcFields
                      ? "File number (As per HDFC Bank Sanction letter):"
                      : "Reference Number:"
                  }}
                  <span class="r1s">{{ order?.referance_id }}</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="r1 ms-2">
                  Account Name:
                  <span class="r1s">{{
                    orderDetail[0]?.account.account_name
                  }}</span>
                </div>
              </div>
              <div class="col">
                <div class="r1">
                  Payment Amount:
                  <span class="r1s">{{ paymentData?.amount }}</span>
                </div>
              </div>
              <div class="col"></div>
            </div>
            <div *ngIf="reviewEmailData.length != 0" class="row">
              <div class="col">
                <div class="r1 ms-2">
                  Checker:
                  <span
                    class="r1s"
                    *ngFor="let item of reviewEmailData; let last = last"
                  >
                    {{ item.reviewer }}
                    <ng-container *ngIf="item?.rejected; else approvalStatus">
                      <span class="form_field">(Rejected)</span>
                    </ng-container>
                    <ng-template #approvalStatus>
                      <ng-container
                        *ngIf="item?.approved; else waitingForApproval"
                      >
                        <span class="form_field">(Approved)</span>
                      </ng-container>
                      <ng-template #waitingForApproval>
                        <span class="form_field"> (Approval Pending)</span>
                      </ng-template>
                    </ng-template>

                    <ng-container *ngIf="!last">,</ng-container>
                    <ng-container *ngIf="last">.</ng-container>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div
            *ngIf="!isDocumentavailable"
            class="alert alert-warning d-flex align-items-center mt-4"
            role="alert"
            style="
              background-color: rgba(255, 40, 7, 0.15);
              border-left: 4px solid #ffc107;
            "
          >
            <i
              class="pi pi-exclamation-triangle me-3"
              style="font-size: 1.5rem; color: #ff9800"
            ></i>
            <div>
              <strong>Document Unavailable:</strong> This document is no longer
              available on the Doqfy portal as it has been deleted as per the
              30-day retention policy. Please download the document from the
              DMS.
            </div>
          </div>
          <div
            class="mt-4"
            *ngIf="
              paymentData?.status === 'PAYMENT_PENDING' ||
              paymentData?.status === 'PAYMENT_SUCCESSFUL' ||
              paymentData?.status === 'PAYMENT_FAILED'|| paymentData?.status === 'PAYMENT_EXPIRED'"
          >
            <span class="title_header mt-4">Payment Details</span>
            <div>
              <div class="data-card">
                <div class="row mt-2">
                  <div class="col-4">
                    <div class="r1 spacing" *ngIf="paymentData.payee_name">
                      <span class="px-1"> Payee Name:</span>
                      <span class="r1s">{{ paymentData.payee_name }} </span>
                    </div>
                    <div class="r1 spacing" *ngIf="!paymentData.payee_name">
                      <span class="px-1"> Transaction Id:</span>
                      <span class="r1s"
                        >{{ paymentData.wallet_transaction_id }}
                      </span>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="r1 spacing" *ngIf="paymentData.payee_email">
                      <span class="px-1">Payee Email:</span
                      ><span class="r1s">{{ maskEmail(paymentData.payee_email)}}</span>
                    </div>
                    <div class="r1 spacing" *ngIf="!paymentData.payee_email">
                      <span class="px-1">Account No:</span
                      ><span class="r1s">{{
                        paymentData.virtual_account_no
                      }}</span>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="r1 spacing" *ngIf="paymentData.payee_contact">
                      <span class="px-1">Payee Mobile:</span>
                      <span class="r1s">{{ maskMobile(paymentData.payee_contact)}}</span>
                    </div>
                    <div class="r1 spacing" *ngIf="!paymentData.payee_contact">
                      <span class="px-1">Billing Type:</span>
                      <span class="r1s">{{ paymentData.billing }}</span>
                    </div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-4">
                    <div class="r1 spacing">
                      <span class="px-1">Status:</span>
                      <span
                        style="
                          width: 20px;
                          color: #151515;
                          padding-inline: 8px !important;
                          padding: 1px;
                          border-radius: 6px;
                          font-weight: 400;
                          font-size: 14px;
                        "
                        [ngStyle]="{
                          'background-color':
                            paymentData?.status === 'PAYMENT_SUCCESSFUL'
                              ? 'rgba(0, 146, 58, 0.15)'
                              : 'rgba(224, 144, 7, 0.15)'
                        }"
                      >
                        {{ paymentData?.status === 'PAYMENT_FAILED' ? 'Payment Cancelled' : paymentData?.display_status }}
                      </span>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="r1 spacing px-1">
                      Amount:
                      <span class="r1s">
                        <a (click)="openPaymentSummary()" class="order-id-link" title="View Payment Summary">
                          {{ paymentData?.amount }}
                        </a>
                      </span>
                    </div>
                  </div>
                  <div
                    class="col-4"
                    *ngIf="
                      paymentData.status === 'PAYMENT_PENDING' &&
                      order.status === 'WAITING_FOR_PAYMENT'
                    "
                  >
                    <app-dropdown
                      [options]="paymentOption"
                      [(ngModel)]="selectedCity"
                      (ngModelChange)="getValue(selectedCity.code)"
                      optionLabel="name"
                      className="button-style-link"
                      placeholder="Payment Options"
                    ></app-dropdown>
                  </div>
                    <div class="col-4" *ngIf="paymentData.payment_time">
                    <div class="r1 spacing px-1">
                      Payment Time:
                      <span class="r1s">{{ paymentData.payment_time | date:'MMM d, y, h:mm a' }}</span>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="r1 spacing px-1">
                      Payment Method:
                      <span class="r1s">{{ paymentData.payment_method }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4" *ngIf="isEstampExists">
            <span class="title_header">E-Stamp Details</span>
            <div *ngFor="let estamp of estamps; let i = index">
              <div class="data-card">
                <div class="row">
                  <div class="row mb-2">
                    <div class="col">
                      <strong class="r1">E-Stamp {{ i + 1 }}</strong>
                    </div>
                  </div>
                  <!-- <div class="row row-cols-2 row-cols-lg-5 g-3 g-lg-4"> -->
                  <div class="col">
                    <div class="r1 spacing">
                      {{
                        showHdfcFields
                          ? "Borrower/s Names:"
                          : "First Party Name :"
                      }}
                      <span class="r1s">{{ estamp.first_party_name }}</span>
                    </div>
                  </div>
                  <div class="col">
                    <div class="r1 spacing">
                      Second Party Name:
                      <span class="r1s">{{ estamp.second_party_name }}</span>
                    </div>
                  </div>
                  <div class="col">
                    <div class="r1 spacing ms-2">
                      Stamp duty amount:
                      <span class="r1s">{{ estamp.stamp_duty_amount }}</span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="r1 spacing">
                      Stamp duty paid by:
                      <span class="r1s">{{ estamp.stamp_duty_paid_by }}</span>
                    </div>
                  </div>
                  <div class="col">
                    <div class="r1 spacing">
                      Execution date:
                      <span class="r1s">{{
                        estamp.execution_date
                          | date
                            : "MMMM d,
                        yyyy"
                      }}</span>
                    </div>
                  </div>
                  <div class="col">
                    <div class="r1 spacing ms-2">
                      Consideration Amount:
                      <span class="r1s">{{ estamp.consideration_amount }}</span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col mt-1"
                    *ngIf="estamp.certificates.length != 0; else showBlankRow"
                  >
                    <p-button
                      label="View Certificate"
                      styleClass="p-button-sm"
                      (click)="
                        onViewCertClick(
                          estamp.certificates,
                          viewCertificateModal
                        )
                      "
                    ></p-button>
                  </div>
                  <ng-template #showBlankRow>
                    <div class="col"></div>
                  </ng-template>
                </div>
                <div class="row">
                  <span *ngIf="estamp.firstPartyPin" class="party-details"
                    >First party details</span
                  >
                  <div class="col" *ngIf="estamp.firstPartyPin">
                    <div class="r1 spacing">
                      Party pin:
                      <span class="r1s">{{ estamp.firstPartyPin }}</span>
                    </div>
                  </div>
                  <div class="col mt-1" *ngIf="estamp.firstPartyOVDValue">
                    <div class="r1 spacing">
                      Document id:
                      <span class="r1s">{{ estamp.firstPartyOVDValue }}</span>
                    </div>
                  </div>
                  <div class="col" *ngIf="estamp.firstPartyOVDType"></div>
                  <div class="col"></div>
                </div>
                <div class="row">
                  <span *ngIf="estamp.secondPartyPin" class="party-details"
                    >Second party details</span
                  >
                  <div class="col" *ngIf="estamp.secondPartyPin">
                    <div class="r1 spacing">
                      Party pin:
                      <span class="r1s">{{ estamp.secondPartyPin }}</span>
                    </div>
                  </div>
                  <div class="col" *ngIf="estamp.secondPartyOVDValue">
                    <div class="r1 spacing">
                      Document id:
                      <span class="r1s">{{ estamp.secondPartyOVDValue }}</span>
                    </div>
                  </div>
                  <div class="col" *ngIf="estamp.secondPartyOVDType"></div>

                  <div class="col"></div>
                </div>
                <div class="row" style="padding-top: 5px">
                  <div class="col">
                    <div class="r1 spacing">
                      Article:
                      <span class="r1s"
                        >{{ estamp.article_code }} - {{ estamp.article }}</span
                      >
                    </div>
                  </div>
                  <div class="col">
                    <div class="r1 spacing">
                      Process By:
                      <span class="r1s">
                        {{
                          estamp.process_type === "PRE_PROCUREMENT"
                            ? "Inventory"
                            : estamp.process_type === "ESBTR"
                              ? "ESBTR"
                              : "On the fly"
                        }}
                      </span>
                    </div>
                  </div>
                  <div class="col" *ngIf="estamp.esbtr_amount">
                    <div class="r1 spacing">
                      ESBTR Amount:
                      <span class="r1s">
                        {{ estamp.esbtr_amount }}
                      </span>
                    </div>
                  </div>
                  <div class="col">
                    <div *ngIf="showHdfcFields" class="r1 spacing">
                      Place of service :
                      <span class="r1s">{{ estampPlace }}</span>
                    </div>
                  </div>
                </div>

                <div
                  class="row"
                  style="padding-top: 5px"
                  *ngIf="estamp.process_type === 'ESBTR'"
                >
                  <div class="col">
                    <div class="r1 spacing">
                      First Party PAN:
                      <span class="r1s">{{ estamp.first_party_pan }}</span>
                    </div>
                  </div>

                  <div class="col">
                    <div class="r1 spacing">
                      Second Party PAN:
                      <span class="r1s">{{ estamp.second_party_pan }}</span>
                    </div>
                  </div>
                  <div class="col"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-4" *ngIf="isEsignExists">
            <span class="title_header mt-4">E-Sign Details</span>
            <div *ngFor="let esign of esigns; let i = index">
              <div class="data-card">
                <div class="row mt-2">
                  <div class="col-12 d-flex justify-content-end">
                    <button
                      *ngIf="
                        !esign.isEditing &&
                        esign.status != 'COMPLETED' &&
                        order.status != 'WAITING_FOR_STAMP' &&
                        order.status != 'INITIATED' &&
                        order.status != 'DRAFT'
                      "
                      (click)="enableEditSigner(i)"
                      pTooltip="Click to edit {{ esign.name }}'s signer details"
                      tooltipPosition="bottom"
                    >
                      <i class="bx bx-edit me-1 edit-cancel"></i>
                    </button>

                    <button
                      *ngIf="
                        !esign.isEditing &&
                        esign.status != 'COMPLETED' &&
                        order.status != 'WAITING_FOR_STAMP' &&
                        order.status != 'INITIATED' &&
                        order.status != 'DRAFT'
                      "
                      (click)="deleteSigner(i)"
                      pTooltip="Click to cancel {{ esign.name }}'s from signing"
                      tooltipPosition="bottom"
                    >
                      <i
                        class="bx bx-trash-alt me-1 edit-cancel"
                        *ngIf="
                          esign.signatory_sequence === 0 &&
                          esign.sign_provider != 'NESL' &&
                          esign.status != 'CANCELLED'
                        "
                      ></i>
                    </button>

                    <button
                      style="font-size: 22px"
                      *ngIf="
                        !isOperationalNeslOrder &&
                        esign.status &&
                        esign.status.trim().toUpperCase() === 'CANCELLED' &&
                        (esign.sign_method?.toUpperCase() === 'AADHAAR' ||
                          esign.sign_method?.toUpperCase() === 'DSC' ||
                          esign.sign_method?.toUpperCase() === 'ELECTRONIC')
                      "
                      pTooltip="Click to re-initiate"
                      (click)="onReinitiateEsign(esign)"
                      tooltipPosition="bottom"
                    >
                      <i class="bx bx-refresh edit-cancel"></i>
                    </button>

                    <button
                      *ngIf="esign.isEditing"
                      class="btn btn-sm btn-success me-2"
                      (click)="saveSignerChanges(i)"
                    >
                      Save
                    </button>
                    <button
                      *ngIf="esign.isEditing"
                      class="btn btn-sm btn-secondary"
                      (click)="cancelSignerEdit(i)"
                    >
                      Cancel
                    </button>
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col">
                    <div class="r1 spacing">
                      <span>Party Name:</span>
                      <span *ngIf="!esign.isEditing" class="r1s">{{
                        esign.name
                      }}</span>
                      <input
                        *ngIf="esign.isEditing"
                        type="text"
                        class="form-control form-control-sm mt-1"
                        [(ngModel)]="esign.tempName"
                        placeholder="Enter party name"
                        pattern="[A-Za-z\s]*"
                        (keypress)="onNameKeyPress($event)"
                        (input)="onNameInput($event, i)"
                      />
                    </div>
                  </div>
                  <div class="col">
                    <div class="r1 spacing">
                      Party Email:
                      <span *ngIf="!esign.isEditing" class="r1s">{{
                        esign.email
                      }}</span>
                      <input
                        *ngIf="esign.isEditing"
                        type="email"
                        maxlength="100"
                        class="form-control form-control-sm mt-1"
                        [(ngModel)]="esign.tempEmail"
                        placeholder="Enter email address"
                      />
                    </div>
                  </div>
                  <div class="col">
                    <div class="r1 spacing">
                      Party Mobile:
                      <span
                        *ngIf="!esign.isEditing && esign.contact_number !== ''"
                        class="r1s"
                        >{{ esign.contact_number }}</span
                      >
                      <span
                        *ngIf="!esign.isEditing && esign.contact_number === ''"
                        class="r1s"
                        >NA</span
                      >
                      <input
                        *ngIf="esign.isEditing"
                        type="tel"
                        class="form-control form-control-sm mt-1"
                        [(ngModel)]="esign.tempContactNumber"
                        placeholder="Enter contact number"
                        maxlength="10"
                        pattern="^[9876][0-9]{9}$"
                        (input)="onMobileInput($event, i)"
                        (keypress)="onMobileKeyPress($event)"
                      />
                    </div>
                  </div>
                </div>

                <div class="row mt-1">
                  <div class="col">
                    <div class="r1 spacing">
                      Sign Mode:
                      <span *ngIf="!esign.isEditing" class="r1s">
                        {{ esign.sign_mode || "NA" }}
                      </span>

                      <app-dropdown
                        *ngIf="
                          esign.isEditing &&
                          esign.sign_method?.toUpperCase() === 'AADHAAR'
                        "
                        class="form-control form-control-sm mt-1"
                        [options]="signModeOptions"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Select Mode"
                        [(ngModel)]="esign.tempSignMode"
                      ></app-dropdown>

                      <span
                        *ngIf="
                          esign.isEditing &&
                          esign.sign_method?.toUpperCase() !== 'AADHAAR'
                        "
                        class="r1s d-block mt-1"
                      >
                        NA
                      </span>
                    </div>
                  </div>
                  <div class="col">
                    <div class="r1 spacing">
                      Status:
                      <span
                        style="
                          width: 20px;
                          color: #151515;
                          padding-inline: 8px !important;
                          padding: 1px;
                          border-radius: 6px;
                          font-weight: 400;
                          font-size: 14px;
                        "
                        [ngStyle]="{
                          'background-color':
                            esign.status === 'COMPLETED'
                              ? 'rgba(0, 146, 58, 0.15)'
                              : esign.status === 'FAILED'
                                ? 'rgba(240, 3, 7, 0.5)'
                                : 'rgba(224, 144, 7, 0.15)'
                        }"
                      >
                        {{ esign.status | titlecase }}
                      </span>
                    </div>
                  </div>

                  <div class="col">
                    <div class="r1 spacing">
                      Sign Method:
                      <span class="r1s">{{ esign.sign_method }}</span>
                    </div>
                  </div>
                </div>

                <div class="row mt-1">
                  <div class="col">
                    <div class="r1 spacing">
                      Signed at:
                      <span class="r1s" *ngIf="esign.signed_at && esign.signed_at !== 'None'">
                        {{ esign.signed_at | date: "MMMM d, yyyy, h.mm a" }}
                      </span>
                      <span class="r1s" *ngIf="!esign.signed_at || esign.signed_at === 'None'">
                        <span
                          style="
                            width: 20px;
                            background-color: rgba(224, 144, 7, 0.15);
                            color: #151515;
                            padding-inline: 10px !important;
                            padding: 1px;
                            border-radius: 6px;
                            font-weight: 400;
                            font-size: 14px;
                          "
                        >
                          N/A
                        </span>
                      </span>
                    </div>
                  </div>

                  <div class="col">
                    <div>
                      <div
                        *ngIf="canShowSendSignLink(esign)"
                        class="r1 spacing clickable"
                      >
                        <a
                          style="
                            color: var(--theme-color);
                            font-family: &quot;Poppins&quot;;
                            font-size: 12px;
                          "
                          (click)="sendSignLink(esign)"
                          >Send Sign Link</a
                        >
                      </div>
                      <div
                        *ngIf="isPrimaryNeslSigner(esign)"
                        class="r1 spacing clickable"
                      >
                        <a
                          style="color: var(--theme-color); font-size: 12px"
                          (click)="getNeslTransactionStatus()"
                          >{{
                            neslActionLoading === 'status'
                              ? 'Loading...'
                              : 'Status'
                          }}</a
                        >
                        <span class="mx-2">|</span>
                        <a
                          style="color: var(--theme-color); font-size: 12px"
                          (click)="reconcileNeslOrder()"
                          >{{
                            neslActionLoading === 'sync' ? 'Syncing...' : 'Sync'
                          }}</a
                        >
                      </div>
                      <div
                        *ngIf="isPrimaryNeslSigner(esign) && neslStatusMessage"
                        class="r1 spacing"
                      >
                        {{ neslStatusMessage }}
                      </div>
                    </div>
                  </div>
                  
                  <div class="col">
                    <div
                      *ngIf="isOperationalNeslOrder || !showCopyLink"
                      class="col clickable"
                      [class.disabled]="!isLinkReady"
                    >
                      <div
                        *ngIf="
                          canShowCopySignLink(esign) &&
                          !isLinkCopied[i]
                        "
                        class="r1 spacing"
                      >
                        <a
                          style="
                            color: #612e86;
                            font-family: &quot;Poppins&quot;;
                            font-size: 12px;
                          "
                          (click)="copySignerLink(esign, i)"
                          target="_blank"
                          >Copy Sign Link</a
                        >
                      </div>
                      <div *ngIf="isLinkCopied[i]" class="r1 spacing">
                        <a
                          style="
                            color: #612e86;
                            font-family: &quot;Poppins&quot;;
                            font-size: 12px;
                          "
                          >Link Copied
                          <i
                            class="bx bxs-check-circle ms-1"
                            style="
                              position: absolute;
                              margin-top: 0px;
                              font-size: 1.1rem !important;
                            "
                          ></i
                        ></a>
                      </div>
                    </div>
                    <div
                      *ngIf="!isOperationalNeslOrder && showCopyLink"
                      class="col clickable"
                    >
                      <div
                        *ngIf="
                          canShowCopySignLink(esign) &&
                          !eSignService.isLinkCopied[i]
                        "
                        class="r1 spacing"
                      >
                        <a
                          style="
                            color: #612e86;
                            font-family: &quot;Poppins&quot;;
                            font-size: 12px;
                          "
                          (click)="copySignerLink(esign, i)"
                          target="_blank"
                          >Copy Sign Link</a
                        >
                      </div>
                      <div
                        *ngIf="eSignService.isLinkCopied[i]"
                        class="r1 spacing"
                      >
                        <a
                          style="
                            color: #612e86;
                            font-family: &quot;Poppins&quot;;
                            font-size: 12px;
                          "
                          >Link Copied
                          <i
                            class="bx bxs-check-circle ms-1"
                            style="
                              position: absolute;
                              margin-top: 0px;
                              font-size: 1.1rem !important;
                            "
                          ></i
                        ></a>
                      </div>
                    </div>
                  </div>
                  <div class="col"></div>
                </div>

                <div
                  class="row mt-2"
                  *ngIf="
                    esign?.provider_details?.failure_reason &&
                    esign?.status === 'FAILED'
                  "
                >
                  <div
                    class="d-flex p-1 rounded-2 shadow-sm"
                    style="
                      background: rgba(224, 7, 7, 0.08);
                      border-left: 5px solid rgba(224, 7, 7, 0.9);
                      width: 50%;
                    "
                  >
                    <div class="d-flex mb-2">
                      <span
                        class="me-2 d-flex align-items-center justify-content-center"
                        style="
                          width: 28px;
                          height: 28px;
                          border-radius: 50%;
                          background: rgba(224, 7, 7, 0.15);
                          color: rgba(224, 7, 7, 0.9);
                          font-weight: bold;
                        "
                      >
                        !
                      </span>
                      <p
                        class="mb-0 fw-bold text-danger"
                        style="font-size: 11px"
                      >
                        Note:
                      </p>
                    </div>

                    <div
                      class="ms-4"
                      style="color: #333; font-size: 11px; line-height: 1.5"
                    >
                      <p class="mb-1" style="font-size: 11px">
                        {{
                          failureReasonMap[
                            esign.provider_details.failure_reason
                          ]
                        }}
                      </p>
                      <p class="mb-0" style="font-size: 11px">
                        <strong>Aadhaar Registered Name is</strong>
                        <span
                          style="color: rgba(224, 7, 7, 0.9); font-weight: 600"
                        >
                          {{ esign.provider_details.uidai.aadhaar_name }}
                        </span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          stroke="none"
                          width="16"
                          height="16"
                          fill="#722C60"
                          class="bi bi-copy ms-1"
                          viewBox="0 0 16 16"
                          (click)="
                            copyToClipboard(
                              esign.provider_details.uidai.aadhaar_name
                            )
                          "
                          style="cursor: pointer; transition: fill 0.3s ease"
                          [title]="justCopied ? 'Copied!' : 'Copy Name'"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
                          />
                        </svg>
                        <small
                          *ngIf="justCopied"
                          class="text-success ms-1"
                          style="font-size: 0.7rem; padding-top: 0.5rem"
                          >Copied!
                        </small>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mt-4" *ngIf="onlyEsign">
            <span class="title_header mt-4">E-Sign Details</span>
            <div *ngFor="let esign of signerDetails; let i = index">
              <div class="data-card">
                <div class="row mt-2">
                  <div class="col-12 d-flex justify-content-end">
                    <button
                      *ngIf="
                        !esign.isEditing &&
                        esign.status != 'COMPLETED' &&
                        order.status != 'WAITING_FOR_STAMP' &&
                        order.status != 'INITIATED'
                      "
                      (click)="enableEditSigner(i)"
                      pTooltip="Click to edit {{ esign.name }}'s signer details"
                      tooltipPosition="bottom"
                    >
                      <i
                        class="bx bx-edit me-1 edit-cancel"
                        *ngIf="esign.sign_provider != 'NESL'"
                      ></i>
                    </button>
                    <button
                      *ngIf="
                        !esign.isEditing &&
                        esign.status != 'COMPLETED' &&
                        order.status != 'WAITING_FOR_STAMP' &&
                        order.status != 'INITIATED'
                      "
                      (click)="deleteSigner(i)"
                      pTooltip="Click to cancel {{ esign.name }}'s from signing"
                      tooltipPosition="bottom"
                    >
                      <i class="bx bx-trash-alt me-1 edit-cancel"></i>
                    </button>
                    <button
                      *ngIf="
                        !isOperationalNeslOrder &&
                        esign.status &&
                        esign.status.trim().toUpperCase() === 'CANCELLED' &&
                        (esign.sign_method?.toUpperCase() === 'AADHAAR' ||
                          esign.sign_method?.toUpperCase() === 'DSC' ||
                          esign.sign_method?.toUpperCase() === 'ELECTRONIC')
                      "
                      pTooltip="Click to re-initiate"
                      (click)="onReinitiateEsign(esign)"
                      tooltipPosition="bottom"
                    >
                      <i
                        class="bx bx-refresh edit-cancel"
                        style="font-size: 22px"
                      ></i>
                    </button>
                    <button
                      *ngIf="esign.isEditing"
                      class="btn btn-sm btn-success me-2"
                      (click)="saveSignerChanges(i)"
                    >
                      Save
                    </button>
                    <button
                      *ngIf="esign.isEditing"
                      class="btn btn-sm btn-secondary"
                      (click)="cancelSignerEdit(i)"
                    >
                      Cancel
                    </button>
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-12 mb-3">
                    <span class="r1 spacing">
                      Signatory {{ i + 1 }}
                    </span>
                  </div>
                  <div class="col">
                    <div class="r1 spacing">
                      <span>Party Name:</span>
                      <span *ngIf="!esign.isEditing" class="r1s">{{
                        esign.name
                      }}</span>
                      <input
                        *ngIf="esign.isEditing"
                        type="text"
                        class="form-control form-control-sm mt-1"
                        [(ngModel)]="esign.tempName"
                        placeholder="Enter party name"
                        pattern="[A-Za-z\s]*"
                        (keypress)="onNameKeyPress($event)"
                        (input)="onNameInput($event, i)"
                      />
                    </div>
                  </div>
                  <div class="col">
                    <div class="r1 spacing">
                      Party Email:
                      <span *ngIf="!esign.isEditing" class="r1s">{{
                        esign.email
                      }}</span>
                      <input
                        *ngIf="esign.isEditing"
                        type="email"
                        maxlength="100"
                        class="form-control form-control-sm mt-1"
                        [(ngModel)]="esign.tempEmail"
                        placeholder="Enter email address"
                      />
                    </div>
                  </div>
                  <div class="col">
                    <div class="r1 spacing">
                      Party Mobile:
                      <span
                        *ngIf="!esign.isEditing && esign.contact_number !== ''"
                        class="r1s"
                        >{{ esign.contact_number }}</span
                      >
                      <span
                        *ngIf="!esign.isEditing && esign.contact_number === ''"
                        class="r1s"
                        >NA</span
                      >
                      <input
                        *ngIf="esign.isEditing"
                        type="tel"
                        class="form-control form-control-sm mt-1"
                        [(ngModel)]="esign.tempContactNumber"
                        placeholder="Enter contact number"
                        maxlength="10"
                        pattern="^[9876][0-9]{9}$"
                        (input)="onMobileInput($event, i)"
                        (keypress)="onMobileKeyPress($event)"
                      />
                    </div>
                  </div>
                </div>

                <div class="row mt-1">
                  <div
                    class="col"
                    *ngIf="esign.contract_relation || esign.CONTRACT_RELATION"
                  >
                    <div class="r1 spacing">
                      Party Relation:
                      <span class="r1s">{{
                        esign.contract_relation || esign.CONTRACT_RELATION
                      }}</span>
                    </div>
                  </div>

                  <div
                    class="col"
                    *ngIf="
                      esign.Official_Document_ID && esign.Official_Document_Type
                    "
                  >
                    <div class="r1 spacing">
                      {{ esign.Official_Document_Type }}:
                      <span class="r1s">{{ esign.Official_Document_ID }}</span>
                    </div>
                  </div>

                  <div class="col" *ngIf="esign.doi || esign.DOI">
                    <div class="r1 spacing">
                      DOI:
                      <span class="r1s">{{ esign.doi || esign.DOI }}</span>
                    </div>
                  </div>
                </div>

                <div class="row mt-1 align-items-center">
                  <div class="col">
                    <div class="r1 spacing">
                      Sign Mode:
                      <span *ngIf="!esign.isEditing" class="r1s">
                        {{ esign.sign_mode || "NA" }}
                      </span>

                      <app-dropdown
                        *ngIf="
                          esign.isEditing &&
                          esign.sign_method?.toUpperCase() === 'AADHAAR'
                        "
                        class="form-control form-control-sm mt-1"
                        [options]="signModeOptions"
                        optionLabel="label"
                        optionValue="value"
                        placeholder="Select Mode"
                        [(ngModel)]="esign.tempSignMode"
                      ></app-dropdown>

                      <span
                        *ngIf="
                          esign.isEditing &&
                          esign.sign_method?.toUpperCase() !== 'AADHAAR'
                        "
                        class="r1s d-block mt-1"
                      >
                        NA
                      </span>
                    </div>
                  </div>
                  <div class="col">
                    <div
                      class="r1 spacing"
                      [pTooltip]="
                        esign?.status === 'ESIGN NOT AFFIXED'
                          ? 'Verification failed: Name or DOB mismatch'
                          : null
                      "
                      tooltipPosition="top"
                    >
                      Status:
                      <span
                        style="
                          width: 20px;
                          color: #151515;
                          padding-inline: 8px !important;
                          padding: 1px;
                          border-radius: 6px;
                          font-weight: 400;
                          font-size: 14px;
                        "
                        [ngStyle]="{
                          'background-color':
                            esign.status === 'COMPLETED'
                              ? 'rgba(0, 146, 58, 0.15)'
                              : esign.status === 'FAILED'
                                ? 'rgba(240, 3, 7, 0.5)'
                                : 'rgba(224, 144, 7, 0.15)'
                        }"
                      >
                        {{ esign.status | titlecase }}
                      </span>
                    </div>
                  </div>

                  <div class="col">
                    <div class="r1 spacing">
                      Sign Method:
                      <span class="r1s">{{ esign.sign_method }}</span>
                    </div>
                  </div>
                </div>

                <div class="row mt-1">
                  <div *ngIf="esign.aadhaar_digits" class="col">
                    <div class="r1 spacing">
                      <span>Aadhaar Digits:</span>
                      <span *ngIf="!esign.isEditing" class="r1s">{{
                        esign.aadhaar_digits
                      }}</span>
                      <input
                        *ngIf="esign.isEditing"
                        type="text"
                        class="form-control form-control-sm mt-1"
                        [(ngModel)]="esign.tempAadhaarDigits"
                        placeholder="Enter last 4 digits"
                        maxlength="4"
                        inputmode="numeric"
                        pattern="[0-9]{4}"
                        (keypress)="allowOnlyDigits($event)"
                      />
                    </div>
                  </div>
                  <div class="col-4">
                    <div
                      class="r1 spacing"
                      *ngIf="esign.cc_emails && esign.cc_emails.length > 0"
                    >
                      First admin email:
                      <span class="r2s">{{ esign.cc_emails[0] }}</span>
                    </div>
                  </div>

                  <div class="col-4">
                    <div
                      class="r1 spacing"
                      *ngIf="esign.cc_emails && esign.cc_emails.length > 1"
                    >
                      Second admin email:
                      <span class="r2s">{{ esign.cc_emails[1] }}</span>
                    </div>
                  </div>
                </div>

                <div class="row mt-1">
                  <div class="col">
                    <div class="r1 spacing">
                      Signed at:
                      <span class="r1s" *ngIf="esign.signed_at && esign.signed_at !== 'None'">
                        {{ esign.signed_at | date: "MMMM d, yyyy, h.mm a" }}
                      </span>
                      <span class="r1s" *ngIf="!esign.signed_at || esign.signed_at === 'None'">
                        <span
                          style="
                            width: 20px;
                            background-color: rgba(224, 144, 7, 0.15);
                            color: #151515;
                            padding-inline: 10px !important;
                            padding: 1px;
                            border-radius: 6px;
                            font-weight: 400;
                            font-size: 14px;
                          "
                        >
                          N/A
                        </span>
                      </span>
                    </div>
                    <!-- <div
                      *ngIf="
                        esign.status &&
                        esign.status.trim().toUpperCase()  === 'CANCELLED' &&
                        (esign.sign_method?.toUpperCase()  === 'AADHAAR' ||
                          esign.sign_method?.toUpperCase() === 'DSC')
                      "
                      class="r1 spacing"
                    >
                      <a
                        style="color: #612e86; font-size: 13px; cursor: pointer"
                        (click)="onReinitiateEsign(esign)"
                        >Re-initiate</a
                      >
                    </div> -->
                  </div>

                  <div class="col">
                    <div>
                      <div
                        *ngIf="canShowSendSignLink(esign)"
                        class="r1 spacing clickable"
                      >
                        <a
                          style="
                            color: var(--theme-color);
                            font-family: &quot;Poppins&quot;;
                            font-size: 12px;
                          "
                          (click)="sendSignLink(esign)"
                          >Send Sign Link</a
                        >
                      </div>
                      <div
                        *ngIf="isPrimaryNeslSigner(esign)"
                        class="r1 spacing clickable"
                      >
                        <a
                          style="color: var(--theme-color); font-size: 12px"
                          (click)="getNeslTransactionStatus()"
                          >{{
                            neslActionLoading === 'status'
                              ? 'Loading...'
                              : 'Status'
                          }}</a
                        >
                        <span class="mx-2">|</span>
                        <a
                          style="color: var(--theme-color); font-size: 12px"
                          (click)="reconcileNeslOrder()"
                          >{{
                            neslActionLoading === 'sync' ? 'Syncing...' : 'Sync'
                          }}</a
                        >
                      </div>
                      <div
                        *ngIf="isPrimaryNeslSigner(esign) && neslStatusMessage"
                        class="r1 spacing"
                      >
                        {{ neslStatusMessage }}
                      </div>
                    </div>
                  </div>

                  <div class="col">
                    <div
                      *ngIf="
                        !isOperationalNeslOrder && showCopyLink && showDownloadDoc
                      "
                      class="col clickable"
                    >
                      <div
                        *ngIf="
                          canShowCopySignLink(esign) &&
                          !eSignService.isLinkCopied[i]
                        "
                        class="r1 spacing"
                      >
                        <a
                          style="
                            color: #612e86;
                            font-family: &quot;Poppins&quot;;
                            font-size: 12px;
                          "
                          (click)="copySignerLink(esign, i)"
                          target="_blank"
                          >Copy Sign Link</a
                        >
                      </div>
                      <div
                        *ngIf="eSignService.isLinkCopied[i]"
                        class="r1 spacing"
                      >
                        <a
                          style="
                            color: #612e86;
                            font-family: &quot;Poppins&quot;;
                            font-size: 12px;
                          "
                          >Link Copied
                          <i
                            class="bx bxs-check-circle ms-1"
                            style="
                              position: absolute;
                              margin-top: 0px;
                              font-size: 1.1rem !important;
                            "
                          ></i
                        ></a>
                      </div>
                    </div>

                    <div
                      *ngIf="isOperationalNeslOrder || !showCopyLink"
                      class="col clickable"
                    >
                      <div
                        *ngIf="
                          canShowCopySignLink(esign) &&
                          !isLinkCopied[i]
                        "
                        class="r1 spacing"
                      >
                        <a
                          style="
                            color: #612e86;
                            font-family: &quot;Poppins&quot;;
                            font-size: 12px;
                          "
                          (click)="copySignerLink(esign, i)"
                          target="_blank"
                          >Copy Sign Link</a
                        >
                      </div>
                      <div *ngIf="isLinkCopied[i]" class="r1 spacing">
                        <a
                          style="
                            color: #612e86;
                            font-family: &quot;Poppins&quot;;
                            font-size: 12px;
                          "
                          >Link Copied
                          <i
                            class="bx bxs-check-circle ms-1"
                            style="
                              position: absolute;
                              margin-top: 0px;
                              font-size: 1.1rem !important;
                            "
                          ></i
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="row mt-2"
                  *ngIf="
                    esign?.provider_details?.failure_reason &&
                    esign?.status === 'FAILED'
                  "
                >
                  <div
                    class="d-flex p-1 rounded-2 shadow-sm"
                    style="
                      background: rgba(224, 7, 7, 0.08);
                      border-left: 5px solid rgba(224, 7, 7, 0.9);
                      width: 50%;
                    "
                  >
                    <div class="d-flex mb-2">
                      <span
                        class="me-2 d-flex align-items-center justify-content-center"
                        style="
                          width: 28px;
                          height: 28px;
                          border-radius: 50%;
                          background: rgba(224, 7, 7, 0.15);
                          color: rgba(224, 7, 7, 0.9);
                          font-weight: bold;
                        "
                      >
                        !
                      </span>
                      <p
                        class="mb-0 fw-bold text-danger"
                        style="font-size: 11px"
                      >
                        Note:
                      </p>
                    </div>

                    <div
                      class="ms-4"
                      style="color: #333; font-size: 11px; line-height: 1.5"
                    >
                      <p class="mb-1" style="font-size: 11px">
                        {{
                          failureReasonMap[
                            esign.provider_details.failure_reason
                          ]
                        }}
                      </p>
                      <p class="mb-0" style="font-size: 11px">
                        <strong>Aadhaar Registered Name is</strong>
                        <span
                          style="color: rgba(224, 7, 7, 0.9); font-weight: 600"
                        >
                          {{ esign.provider_details.uidai.aadhaar_name }}
                        </span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          stroke="none"
                          width="16"
                          height="16"
                          fill="#722C60"
                          class="bi bi-copy ms-1"
                          viewBox="0 0 16 16"
                          (click)="
                            copyToClipboard(
                              esign.provider_details.uidai.aadhaar_name
                            )
                          "
                          style="cursor: pointer; transition: fill 0.3s ease"
                          [title]="justCopied ? 'Copied!' : 'Copy Name'"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
                          />
                        </svg>
                        <small
                          *ngIf="justCopied"
                          class="text-success ms-1"
                          style="font-size: 0.7rem; padding-top: 0.5rem"
                          >Copied!
                        </small>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="d-flex justify-content-end"
        style="margin-top: 1rem; margin-bottom: 2rem"
      >
        <div *ngIf="isAbcl">
          <span>
            <i
              class="pi pi-info-circle"
              pTooltip="The document will be available on the Doqfy portal only for 30 days from the completion of signing. Please ensure it is moved to the DMS for seamless access after this period."
              tooltipPosition="right"
              style="
                padding-right: 10px;
                padding-top: 5px;
                font-size: 1.2rem;
                color: #2196f3;
                cursor: pointer;
              "
            ></i>
          </span>
        </div>
        <div>
          <button
            type="button"
            (click)="back()"
            class="btn btn-outline-custom me-4"
          >
            Back
          </button>
        </div>
        <div *ngIf="reviewMode">
          <div *ngIf="!reviewerDetails.approved && !reviewerDetails.rejected">
            <button
              class="button-style_cancel me-2"
              (click)="rejectOrder()"
              type="button"
            >
              <i
                class="bx bx-x-circle"
                style="
                  position: absolute;
                  margin-top: 0px;
                  font-size: 1.1rem !important;
                "
              ></i>
              <span style="padding-left: 30px"> Reject Order </span>
            </button>

            <button
              class="button-style me-2"
              (click)="approveOrder()"
              type="button"
            >
              <i
                class="bx bxs-check-circle"
                style="
                  position: absolute;
                  margin-top: 0px;
                  font-size: 1.1rem !important;
                "
              ></i>
              <span style="padding-left: 30px"> Approve Order </span>
            </button>
          </div>
        </div>
        <div *ngIf="!reviewMode">
          <button
            *ngIf="order?.status != 'WAITING_FOR_APPROVAL'"
            class="button-style me-2"
            type="button"
            (click)="orderView(viewStampOrder)"
            [disabled]="!showDownloadDoc"
            [class.disabled]="!showDownloadDoc"
          >
            <i
              class="pi pi-eye"
              style="
                position: absolute;
                margin-top: 0px;
                font-size: 1.1rem !important;
              "
            ></i>
            <span style="padding-left: 30px">Document </span>
          </button>

          <button
            *ngIf="canOpenNeslRetrigger"
            class="button-style"
            type="button"
            (click)="navigateToRetrigger()"
            style="margin-right: 8px"
          >
            <i
              class="pi pi-pencil"
              style="
                position: absolute;
                margin-top: 0px;
                font-size: 1.1rem !important;
              "
            ></i>
            <span style="padding-left: 30px">Edit–Reinitiate</span>
          </button>

          <button
            class="button-style"
            type="button"
            [disabled]="!showDownloadDoc"
            (click)="orderDownload()"
            [class.disabled]="!showDownloadDoc"
          >
            <i
              class="pi pi-download"
              style="
                position: absolute;
                margin-top: 0px;
                font-size: 1.1rem !important;
              "
            ></i>
            <span style="padding-left: 30px">Document </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="noData">
  <ng-container>
    <tr>
      <td colspan="8" style="text-align: center; font-size: large">
        No Records Found
      </td>
    </tr>
  </ng-container>
</div>

<ng-template #viewStampOrder let-modal>
  <div class="modal-header">
    <h4 class="title_five" id="modal-basic-title">View Document</h4>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body" style="background-color: #f3eeee; height: 100%">
    <div class="iframe_border">
      <iframe
        [src]="pdfSource"
        allow-same-origin
        class="col-md-12 text-center this-is-iframe"
        style="
          height: 40rem;
          border-width: thin;
          background-color: #ffffff;
          transform: scale(1);
          transform-origin: top;
        "
      ></iframe>
    </div>
  </div>
</ng-template>

<ng-template #sendreminder let-modal>
  <div class="modal-header send-remainder-container">
    <h4 class="title_five" id="modal-basic-title">send Reminder</h4>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      (click)="closeModel()"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body" style="background-color: #f3eeee; height: 100%">
    <div class="form_outline_sty">
      <div class="row form_inputFields">
        <div class="col-lg-6 col-sm-6 col-md-6">
          <span class="form_field ms-2">Select Date</span>
          <span class="color_red">*</span>

          <div class="overlay" style="display: block">
            <input
              type="date"
              [(ngModel)]="selectedDate"
              style="font-size: 0.8rem"
              class="form-control date-input"
              placeholder="Select Date"
              inputId="dateformat"
              dateFormat="dd/mm/yy"
            />
          </div>
        </div>
        <div class="col-lg-2 col-sm-2 col-md-2" style="margin-top: 1rem"></div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #viewCertificateModal let-modal>
  <div class="modal-header">
    <strong>Certificate Details</strong>
    <button
      style="margin-left: 250px"
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="container">
      <div class="mt-1">
        <app-data-table
          [columns]="certificateColumns"
          [data]="selectedStampData"
          [paginator]="false">
        </app-data-table>
      </div>
    </div>
  </div>
</ng-template>

<div class="toast_display_layer">
  <p-toast></p-toast>
</div>

<ng-template #viewReviewOrder let-modal>
  <div class="modal-header">
    <h4 class="title_five" id="modal-basic-title">Review Document</h4>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      (click)="closeModel()"
      aria-label="Close"
    ></button>
  </div>
  <div
    class="modal-body"
    style="background-color: #f3eeee; height: 85vh; overflow-y: hidden"
  >
    <div class="card ms-3 me-3">
      <div class="iframe_border">
        <iframe
          [src]="pdfSource"
          allow-same-origin
          class="col-md-12 text-center this-is-iframe"
          style="
            height: 70vh;
            border-width: thin;
            background-color: #ffffff;
            transform: scale(1);
            transform-origin: top;
          "
        ></iframe>
      </div>
    </div>

    <div *ngIf="reviewMode">
      <div
        *ngIf="!reviewerDetails.approved && !reviewerDetails.rejected"
        class="card ms-3 me-3"
        style="
          justify-content: flex-end;
          display: flex;
          flex-direction: row;
          padding: 20px;
        "
      >
        <button
          class="button-style me-2"
          (click)="approveOrder()"
          type="button"
        >
          <i
            class="bx bxs-check-circle"
            style="
              position: absolute;
              margin-top: 0px;
              font-size: 1.1rem !important;
            "
          ></i>
          <span style="padding-left: 30px"> Approve Order </span>
        </button>
        <button
          class="button-style_cancel me-2"
          (click)="rejectOrder()"
          type="button"
        >
          <i
            class="bx bx-x-circle"
            style="
              position: absolute;
              margin-top: 0px;
              font-size: 1.1rem !important;
            "
          ></i>
          <span style="padding-left: 30px"> Reject Order </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #paymentModal let-modal>
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      (click)="closeModel()"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-content">
    <div class="modal-body">
      <div class="container">
        <div
          class="d-flex flex-row form_inputFields ms-3 me-3 form_outline_sty"
        >
          <div class="col-lg-4 col-sm-4 col-md-4">
            <span class="form_field">Payee Name</span
            ><span class="color_red">*</span>
            <input
              class="form-control edit_input"
              [(ngModel)]="paymentData.payee_name"
              pInputText
              type="text"
              readonly="true"
            />
          </div>
          <div class="col-lg-4 col-sm-4 col-md-4">
            <span class="form_field"> Payee Email</span
            ><span class="color_red">*</span>
            <input
              class="form-control edit_input"
              [(ngModel)]="paymentData.payee_email"
              pInputText
              type="text"
              readonly="true"
            />
          </div>
          <div class="col-lg-4 col-sm-4 col-md-4">
            <span class="form_field">Payee Contact</span
            ><span class="color_red">*</span>
            <input
              class="form-control edit_input"
              [(ngModel)]="paymentData.payee_contact"
              placeholder="Enter Number"
              pInputText
              type="text"
              readonly="true"
            />
          </div>
        </div>
      </div>
      <div
        class="row form_inputFields ms-3 me-3 form_outline_sty"
        style="padding-right: 1rem"
      >
        <app-data-table
          *ngIf="stampDetails.length != 0"
          [columns]="stampBillColumns"
          [data]="stampDetails"
          [paginator]="false">
          <ng-template appTableCell="s_no" let-row let-i="index">{{ i + 1 }}</ng-template>
          <ng-template appTableCell="price" let-row>{{ usedCurrency }}{{ row.price }}</ng-template>
          <ng-template appTableCell="quantity" let-row>1</ng-template>
          <ng-template appTableCell="amount" let-row>{{ usedCurrency }} {{ row.amount }}</ng-template>

          <ng-template appTableFooter>
            <tr>
              <th colspan="6" scope="row">Total</th>
              <td>{{ usedCurrency }} {{ getTotalStampValue() }}</td>
            </tr>
          </ng-template>
        </app-data-table>

        <app-data-table
          *ngIf="signDetails.length != 0"
          [columns]="signBillColumns"
          [data]="esignBillRows"
          [paginator]="false">
          <ng-template appTableCell="serial" let-row>{{ row.serial }}</ng-template>
          <ng-template appTableCell="method" let-row>{{ row.method }}</ng-template>
          <ng-template appTableCell="price" let-row>{{ usedCurrency }} {{ row.price }}</ng-template>
          <ng-template appTableCell="quantity" let-row>{{ row.qty }}</ng-template>
          <ng-template appTableCell="amount" let-row>{{ usedCurrency }} {{ row.amount }}</ng-template>

          <ng-template appTableFooter>
            <tr>
              <th colspan="4" scope="row">Total</th>
              <td>{{ usedCurrency }} {{ getTotalEsignValue() }}</td>
            </tr>
          </ng-template>
        </app-data-table>

        <div class="payment-section">
          <span class="form_field" style="font-size: 12px"
            >Payable Amount :
          </span>
          <span class="payable-amount"
            >{{ usedCurrency }} {{ paymentData.amount }}</span
          ><br />
        </div>
      </div>
      <p-button
        label="Pay Now"
        (click)="payBillNow()"
        styleClass="p-button-sm-outline"
        class="pay-now"
      ></p-button>
    </div>
  </div>
</ng-template>
<ng-template #paymentPopup let-modal>
  <div class="modal-content" id="payment-modal">
    <div class="modal-body">
      <div class="payment-container">
        <div class="payment-message">
          <div class="spinner"></div>
          <h1>Payment is Processing</h1>
          <p>
            Please do not refresh your page or click the "Back" or "Close"
            button<br />
            until the process is complete.
          </p>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<div *ngIf="isBulkCatUploadOrder" class="bcg">
  <div class="mb-2">
    <div class="page_responsive card">
      <div class="card-body">
        <div class="container">
          <div class="d-flex justify-content-between mb-3">
            <span class="title_header">
              {{
                bulkOrderData?.status === "AWAITING_APPROVAL"
                  ? "Review Order"
                  : "Order Summary"
              }}
            </span>
          </div>
          <div class="data-card">
            <div class="row">
              <div class="col">
                <div class="r1 ms-2">
                  Bulk Order UUID:
                  <span
                    class="r1s"
                    pTooltip="{{ bulkOrderData?.bulk_order_uuid }}"
                    tooltipPosition="top"
                  >
                    {{ bulkOrderData?.bulk_order_uuid | slice: 0 : 20 }}...
                  </span>
                </div>
              </div>
              <div class="col">
                <div class="r1">
                  Client ID:
                  <span class="r1s">{{ bulkOrderData?.client_id }}</span>
                </div>
              </div>
              <div class="col">
                <div class="r1">
                  Status:
                  <span
                    [ngStyle]="{
                      'background-color':
                        bulkOrderData?.status === 'COMPLETED'
                          ? 'rgba(0, 146, 58, 0.15)'
                          : 'rgba(224, 144, 7, 0.15)'
                    }"
                    style="
                      color: #151515;
                      padding-inline: 9px !important;
                      padding: 1px;
                      border-radius: 6px;
                      font-weight: 400;
                      font-size: 14px;
                      margin-left: 2px;
                    "
                  >
                    {{ getBulkStatusLabel(bulkOrderData?.status) }}
                  </span>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div class="r1 ms-2">
                  Created At:
                  <span class="r1s">
                    {{
                      bulkOrderData?.created_at | date: "MMMM d, yyyy, h.mm a"
                    }}
                  </span>
                </div>
              </div>
              <div class="col">
                <div class="r1">
                  Total Files:
                  <span class="r1s">{{ bulkOrderData?.total_files }}</span>
                </div>
              </div>
              <div class="col">
                <div class="r1" *ngIf="bulkOrderData?.reviewer_email">
                  Reviewer Email:
                  <span class="r1s">{{ bulkOrderData?.reviewer_email }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4">
            <span class="title_header">Bulk PDF Details</span>

            <div *ngFor="let file of bulkOrderData?.details; let i = index">
              <div class="data-card mt-2">
                <div class="row">
                  <div class="col">
                    <div class="r1 ms-2">
                      File No:
                      <span class="r1s">{{ i + 1 }}</span>
                    </div>
                  </div>
                  <div class="col">
                    <div class="r1">
                      File Name:
                      <span
                        class="r1s"
                        pTooltip="{{ file.file_name }}"
                        tooltipPosition="top"
                      >
                        {{
                          file.file_name.length > 30
                            ? (file.file_name | slice: 0 : 30) + "..."
                            : file.file_name
                        }}
                      </span>
                    </div>
                  </div>
                  <div class="col">
                    <div class="r1">
                      File ID:
                      <span class="r1s">{{ file.file_id }}</span>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <div class="r1 ms-2">
                      Reference ID:
                      <span class="r1s">{{ file.referance_id }}</span>
                    </div>
                  </div>
                  <div class="col">
                    <div class="r1">
                      Order ID:
                      <span class="r1s" *ngIf="file.order_id; else noOrderId">
                        {{ file.order_id }}
                      </span>
                      <ng-template #noOrderId>
                        <span
                          style="
                            background-color: rgba(224, 144, 7, 0.15);
                            color: #151515;
                            padding-inline: 8px;
                            padding: 1px;
                            border-radius: 6px;
                            font-size: 13px;
                          "
                          >Pending</span
                        >
                      </ng-template>
                    </div>
                  </div>
                  <div class="col">
                    <div class="r1">
                      Status:
                      <span
                        [ngStyle]="{
                          'background-color':
                            file.status === 'COMPLETED'
                              ? 'rgba(0, 146, 58, 0.15)'
                              : file.status === 'FAILED'
                                ? 'rgba(240, 3, 7, 0.15)'
                                : 'rgba(224, 144, 7, 0.15)'
                        }"
                        style="
                          color: #151515;
                          padding-inline: 8px;
                          padding: 1px;
                          border-radius: 6px;
                          font-size: 13px;
                        "
                      >
                        {{ getBulkStatusLabel(file.status) }}
                      </span>
                      <i
                        *ngIf="bulkOrderData?.status === 'AWAITING_APPROVAL'"
                        class="pi pi-eye ms-2"
                        style="cursor: pointer; color: #661ac9; font-size: 1rem"
                        title="View Document"
                        (click)="viewFilePdf(file.referance_id, viewBulkFilePdf)"
                      ></i>
                    </div>
                  </div>
                </div>

                <!-- Error log row — only if present -->
                <div class="row" *ngIf="file.error_log">
                  <div class="col">
                    <div class="r1 ms-2" style="color: #d9534f">
                      <i class="bx bx-error-circle me-1"></i>
                      Error:
                      <span style="font-size: 12px">{{ file.error_log }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="d-flex justify-content-end"
        style="margin-top: 1rem; margin-bottom: 2rem; padding-right: 1rem"
      >
        <div>
          <button
            type="button"
            (click)="back()"
            class="btn btn-outline-custom me-4"
          >
            Back
          </button>
        </div>

        <div
          *ngIf="bulkOrderData?.status === 'AWAITING_APPROVAL'"
          class="me-2"
        >
          <button
            type="button"
            class="button-style_cancel me-2"
            (click)="downloadBulkExcel()"
            [ngClass]="{
              'btn-disabled': bulkOrderData?.reviewer_email !== userName
            }"
            [style.opacity]="
              bulkOrderData?.reviewer_email !== userName ? '0.5' : '1'
            "
            [style.pointer-events]="
              bulkOrderData?.reviewer_email !== userName ? 'none' : 'auto'
            "
            [style.cursor]="
              bulkOrderData?.reviewer_email !== userName
                ? 'not-allowed'
                : 'pointer'
            "
          >
            <i class="bx bx-download me-1"></i>
            Download Excel
          </button>
        </div>
        <div *ngIf="bulkOrderData?.status === 'AWAITING_APPROVAL'">
          <button
            class="button-style_cancel me-2"
            (click)="rejectBulkOrder()"
            type="button"
            [ngClass]="{
              'btn-disabled': bulkOrderData?.reviewer_email !== userName
            }"
            [style.opacity]="
              bulkOrderData?.reviewer_email !== userName ? '0.5' : '1'
            "
            [style.pointer-events]="
              bulkOrderData?.reviewer_email !== userName ? 'none' : 'auto'
            "
            [style.cursor]="
              bulkOrderData?.reviewer_email !== userName
                ? 'not-allowed'
                : 'pointer'
            "
          >
            <i
              class="bx bx-x-circle"
              style="
                position: absolute;
                margin-top: 0px;
                font-size: 1.1rem !important;
              "
            ></i>
            <span style="padding-left: 30px">Reject Order</span>
          </button>
          <button
            class="button-style me-2"
            (click)="approveBulkOrder()"
            type="button"
            [ngClass]="{
              'btn-disabled': bulkOrderData?.reviewer_email !== userName
            }"
            [style.opacity]="
              bulkOrderData?.reviewer_email !== userName ? '0.5' : '1'
            "
            [style.pointer-events]="
              bulkOrderData?.reviewer_email !== userName ? 'none' : 'auto'
            "
            [style.cursor]="
              bulkOrderData?.reviewer_email !== userName
                ? 'not-allowed'
                : 'pointer'
            "
          >
            <i
              class="bx bxs-check-circle"
              style="
                position: absolute;
                margin-top: 0px;
                font-size: 1.1rem !important;
              "
            ></i>
            <span style="padding-left: 30px">Approve Order</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #viewBulkFilePdf let-modal>
  <div class="modal-header">
    <h4 class="title_five" id="modal-basic-title">View Document</h4>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body" style="background-color: #f3eeee; height: 100%">
    <div class="iframe_border">
      <iframe
        [src]="pdfSource"
        allow-same-origin
        class="col-md-12 text-center this-is-iframe"
        style="
          height: 40rem;
          border-width: thin;
          background-color: #ffffff;
          transform: scale(1);
          transform-origin: top;
        "
      ></iframe>
    </div>
  </div>
</ng-template>
<ng-template #rejectReasonModal let-modal>
  <div class="modal-header">
    <h5 class="title_five" id="reject-modal-title">Reject Bulk Order</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss()"
    ></button>
  </div>

  <div class="modal-body">
    <label class="form-label" style="font-size: 0.85rem; font-weight: 600">
      Rejection Reason <span style="color: red">*</span>
    </label>
    <textarea
      class="form-control"
      rows="4"
      placeholder="Enter reason for rejection..."
      [(ngModel)]="rejectionReason"
      maxlength="500"
      style="font-size: 0.85rem; resize: none"
    ></textarea>
    <div
      *ngIf="rejectionSubmitted && !rejectionReason?.trim()"
      style="color: #d9534f; font-size: 0.78rem; margin-top: 4px"
    >
      Rejection reason is required.
    </div>
    <div style="text-align: right; font-size: 0.75rem; color: #888; margin-top: 4px">
      {{ rejectionReason?.length || 0 }}/500
    </div>
  </div>

  <div class="modal-footer" style="border-top: 1px solid #e8ecf3">
    <button
      type="button"
      class="btn btn-outline-custom"
      (click)="modal.dismiss()"
    >
      Cancel
    </button>
    <button
      type="button"
      class="button-style_cancel"
      (click)="confirmRejectBulkOrder()"
      [style.opacity]="!rejectionReason?.trim() ? '0.6' : '1'"
      [style.cursor]="!rejectionReason?.trim() ? 'not-allowed' : 'pointer'"
    >
      <i
        class="bx bx-x-circle"
        style="position: absolute; margin-top: 0px; font-size: 1.1rem !important"
      ></i>
      <span style="padding-left: 30px">Reject Order</span>
    </button>
  </div>
</ng-template>


<ng-template #paymentSummaryModal let-modal>
    <div class="modal-header">
      <h4 class="title_five">Payment Summary</h4>
      <button
        type="button"
        class="btn-close"
        (click)="modal.dismiss('Cross click')"
        aria-label="Close"
      ></button>
    </div>
    <div class="modal-body">
      <div *ngIf="paymentAmountData" class="summary-grid">
        <div class="summary-row">
          <span class="summary-label">Stamp Amount:</span>
          <span class="summary-value">{{
            paymentAmountData.stamp_amount | currency : "INR" : "symbol" : "1.2-2"
          }}</span>
        </div>
        <div class="summary-row">
          <span class="summary-label">Stamp Convenience:</span>
          <span class="summary-value">{{
            paymentAmountData.stamp_convenience
              | currency : "INR" : "symbol" : "1.2-2"
          }}</span>
        </div>
        <div class="summary-row">
          <span class="summary-label">eSign Convenience:</span>
          <span class="summary-value">{{
            paymentAmountData.esign_convenience
              | currency : "INR" : "symbol" : "1.2-2"
          }}</span>
        </div>
        <div *ngIf="paymentAmountData.cess > 0" class="summary-row">
          <span class="summary-label">Cess:</span>
          <span class="summary-value">{{
            paymentAmountData.cess
              | currency : "INR" : "symbol" : "1.2-2"
          }}</span>
        </div>
        <div class="summary-row">
          <span class="summary-label">GST:</span>
          <span class="summary-value">{{
            paymentAmountData.tax | currency : "INR" : "symbol" : "1.2-2"
          }}</span>
        </div>
        <div class="summary-row">
          <span class="summary-label">Handling Fee:</span>
          <span class="summary-value">{{
            paymentAmountData.handling_fee | currency : "INR" : "symbol" : "1.2-2"
          }}</span>
        </div>
        <div class="summary-row total-row">
          <span class="summary-label">Total Amount:</span>
          <span class="summary-value">{{
            paymentAmountData.total_amount | currency : "INR" : "symbol" : "1.2-2"
          }}</span>
        </div>
      </div>
      <div *ngIf="!paymentAmountData" class="loading-message">
        Loading payment details...
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-secondary"
        (click)="modal.close('Close click')"
      >
        Close
      </button>
    </div>
</ng-template>